module.exports = Object.freeze({
  BRAND: "YESolutions",
}); // https://stackoverflow.com/a/21247500/5747944
